import Vue from 'vue';
// @ts-ignore
import vBtn from 'vuetify/lib/components/VBtn';
export default Vue.extend({
    name: 'mobLimitBidsTableDetailItem',
    props: {
        closing: {
            type: Boolean,
            required: true
        },
        section: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        direction: {
            type: String,
            required: true
        },
        positionPrice: {
            type: Object,
            required: true
        },
        volume: {
            type: [Object, String],
            required: true
        }
    },
    render(createElement) {
        const vm = this;
        const filters = vm.$options.filters;
        const positionPrice = createElement('div', { class: 'tableDetailsItem_row' }, [
            createElement('span', { class: 'tableDetailsItem_title' }, vm.$t('mainPage.tables.tableHeaders.executionPrice')),
            createElement('span', { class: 'tableDetailsItem_value' }, filters.formatMoney(vm.positionPrice.toNumber()))
        ]);
        const volume = createElement('div', { class: 'tableDetailsItem_row' }, [
            createElement('span', { class: 'tableDetailsItem_title' }, vm.$t('mainPage.tables.common.value')),
            createElement('span', { class: 'tableDetailsItem_value' }, vm.volume.isZero() ? '' : filters.formatMoney(vm.volume.toNumber()))
        ]);
        const direction = createElement('div', { class: 'tableDetailsItem_row' }, [
            createElement('span', { class: 'tableDetailsItem_title' }, vm.$t('mainPage.tables.tableHeaders.orderType')),
            createElement('span', { class: 'tableDetailsItem_value' }, vm.direction)
        ]);
        const section = createElement('div', { class: 'tableDetailsItem_row' }, [
            createElement('span', { class: 'tableDetailsItem_title' }, vm.$t('mainPage.tables.tableHeaders.section')),
            createElement('span', { class: 'tableDetailsItem_value' }, vm.section)
        ]);
        const closePosition = createElement('v-btn', {
            class: 'btn btn--gradient-border--accent btn--accent mt-2 mx-3',
            style: {
                width: 'calc(100% - 24px)'
            },
            props: {
                loading: vm.closing,
                height: 32
            },
            on: {
                click: () => { vm.$emit('cancelPosition'); }
            }
        }, vm.$t('mainPage.tables.limits.removeApplication'));
        return createElement('div', { class: 'tableDetailsItem mt-2' }, [
            positionPrice,
            volume,
            direction,
            section,
            closePosition
        ]);
    },
    components: {
        'v-btn': vBtn
    }
});
